module.exports = __webpack_public_path__ + "media/images/partner/media/stadtteilliebe-56cc737fa59f46aa881ce2e0bbbcd4d6.png";